import React from 'react';
import PropTypes from 'prop-types';

import isNil from 'lodash/isNil';

import {
    Spacer,
    Table,
    Text,
} from '@zillow/constellation';

import numberUtils from 'app/shared/utils/numberUtils';
import stringHelper from 'app/shared/utils/stringHelper';

// styles
import './style.scss';

const propTypes = {
    leadData: PropTypes.object.isRequired,
};

function LeadResume({ leadData }) {
    // const { zip } = leadData; // zip is not renters coming from zip - do not display

    const parseSmoking = smoking => smoking && (smoking === 'true' ? 'Yes' : 'No');

    const parsePets = (pets) => {
        const PET = {
            CAT: 'cat',
            DOG: 'dog',
            OTHER: 'other',
        };

        const DOG_SIZE = {
            small: '<25lbs',
            medium: '25-50lbs',
            large: '>50lbs',
        };

        // cats
        let numCats = 0;
        let catString = '';
        // no need for cat array

        // dogs
        let dogString = '';
        const dogsArr = [];

        // other
        let petOtherString = '';
        const petOtherArr = [];

        // total
        const petsArr = [];

        // pets can be empty array or undefined
        if (Array.isArray(pets) && pets.length > 0) {
            let size = '';
            let type = '';
            let description = '';

            // calculate pet counts
            pets.forEach((pet) => {
                description = pet.description;
                type = pet.type.toLowerCase();
                size = isNil(pet.size) ? '' : pet.size.toLowerCase();

                if (type === PET.DOG) {
                    dogsArr.push(`1 ${size} ${PET.DOG} (${DOG_SIZE[size]})`);
                } else if (type === PET.CAT) {
                    numCats += 1;
                    catString = `${stringHelper.pluralize(numCats, 'cat', 'cats')}`;
                } else if (type === PET.OTHER) {
                    petOtherArr.push(description);
                }
            });
        }

        // check dogs
        if (dogsArr.length > 0) {
            dogString = dogsArr.join(', ');
            petsArr.push(dogString);
        }

        // check cats
        if (catString.length > 0) {
            petsArr.push(catString);
        }

        if (petOtherArr.length > 0) {
            petOtherString = petOtherArr.join(', ');
            petsArr.push(petOtherString);
        }

        return pets.length === 0 ?
            undefined :
            petsArr.join(', ');
    };

    const {
        credit,
        employer,
        isSmoker,
        income,
        jobTitle,
        moveInTimeframe,
        pets,
        numOccupants,
        reasonForMoving,
    } = leadData.attributes;

    // parse values
    const parsedIncome = income ? `${numberUtils.asCurrency(income)}` : undefined;
    const parsedPets = parsePets(pets || []);
    const parsedSmoking = parseSmoking(isSmoker);
    const title = 'Renter profile';

    // table row titles
    const titleMoveIn = 'Move in timeframe';
    const titleCredit = 'Credit score';
    const titleIncome = 'Household income';
    const titleJob = 'Job title';
    const titleEmployer = 'Employer';
    const titleNumOccupants = 'Adult tenants';
    const titlePets = 'Pets';
    const titleSmoking = 'Smoking';
    // const titleMovingFromZip = 'Moving from';
    const titleReasonForMoving = 'Reason for moving';

    const renderTableRow = (value, title) => {
        if (isNil(value)) {
            return null;
        }
        return (
            <Table.Row data-test={`${title}-table-row`}>
                <Table.Cell>
                    <Text><b>{title}</b></Text>
                </Table.Cell>
                <Table.Cell>
                    <Text data-test={`${title}-table-col-value`}>{value}</Text>
                </Table.Cell>
            </Table.Row>
        );
    };

    return (
        <div className="LeadResume">
            <Spacer paddingBottom="md">
                <Text fontType="h4">{title}</Text>
            </Spacer>
            <Table
                className="LeadResume-table"
                appearance="barebones"
                aria-label="Small-sized horizontal table"
                size="sm"
            >
                <Table.Body>
                    {renderTableRow(moveInTimeframe, titleMoveIn)}
                    {renderTableRow(credit, titleCredit)}
                    {renderTableRow(parsedIncome, titleIncome)}
                    {renderTableRow(jobTitle, titleJob)}
                    {renderTableRow(employer, titleEmployer)}
                    {renderTableRow(numOccupants, titleNumOccupants)}
                    {renderTableRow(parsedPets, titlePets)}
                    {renderTableRow(parsedSmoking, titleSmoking)}
                    {/* {renderTableRow(zip, titleMovingFromZip)}*/}
                    {renderTableRow(reasonForMoving, titleReasonForMoving)}
                </Table.Body>
            </Table>
        </div>
    );
}

LeadResume.propTypes = propTypes;

export default LeadResume;
